/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_VisitorInputs */

const en_admin_dashboard_visitor = /** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitor`)
};

const ro_admin_dashboard_visitor = /** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizitator`)
};

/** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */
const de_admin_dashboard_visitor = en_admin_dashboard_visitor;

/** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */
const es_admin_dashboard_visitor = en_admin_dashboard_visitor;

/** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */
const fr_admin_dashboard_visitor = en_admin_dashboard_visitor;

/** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */
const it_admin_dashboard_visitor = en_admin_dashboard_visitor;

/** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */
const pt_br2_admin_dashboard_visitor = en_admin_dashboard_visitor;

/** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */
const pl_admin_dashboard_visitor = en_admin_dashboard_visitor;

/** @type {(inputs: Admin_Dashboard_VisitorInputs) => LocalizedString} */
const hu_admin_dashboard_visitor = en_admin_dashboard_visitor;

/**
* | output |
* | --- |
* | "Visitor" |
*
* @param {Admin_Dashboard_VisitorInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_visitor = /** @type {((inputs?: Admin_Dashboard_VisitorInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_VisitorInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_visitor(inputs)
	if (locale === "de") return de_admin_dashboard_visitor(inputs)
	if (locale === "es") return es_admin_dashboard_visitor(inputs)
	if (locale === "fr") return fr_admin_dashboard_visitor(inputs)
	if (locale === "it") return it_admin_dashboard_visitor(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_visitor(inputs)
	if (locale === "pl") return pl_admin_dashboard_visitor(inputs)
	if (locale === "hu") return hu_admin_dashboard_visitor(inputs)
	return ro_admin_dashboard_visitor(inputs)
});
export { admin_dashboard_visitor as "admin.dashboard.visitor" }